import { render } from "./BackupList.vue?vue&type=template&id=6c4940e8"
import script from "./BackupList.vue?vue&type=script&lang=js"
export * from "./BackupList.vue?vue&type=script&lang=js"

import "./BackupList.vue?vue&type=style&index=0&id=6c4940e8&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__